'use client'

import { useSession } from 'next-auth/react'
import { UserRole } from '@/types'

export function useAuth() {
  const { data: session, status } = useSession()

  const user = session?.user

  const isAuthenticated = status === 'authenticated'
  const isLoading = status === 'loading'

  const hasRole = (role: UserRole): boolean => {
    if (!user?.role) return false

    const roleHierarchy: Record<UserRole, number> = {
      GUEST: 0,
      LOCATION_ADMIN: 1,
      GLOBAL_ADMIN: 2,
    }

    return roleHierarchy[user.role] >= roleHierarchy[role]
  }

  const isAdmin = (): boolean => {
    if (!user?.role) return false
    return user.role === 'LOCATION_ADMIN' || user.role === 'GLOBAL_ADMIN'
  }

  return {
    user,
    session,
    isAuthenticated,
    isLoading,
    hasRole,
    isAdmin,
  }
}
